export default "__VITE_ASSET__Cu76VbdM__"